import { c as _c } from "react/compiler-runtime";
import { postOrgOnboardingConfigsByIdCopyMutation } from '@onefootprint/fetch-dashboard';
import { useRequestErrorToast } from '@onefootprint/hooks';
import { useToast } from '@onefootprint/ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
const useDuplicatePlaybook = () => {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "header.leftHeaderActions.duplicatePlaybook.feedback"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t0);
  const queryClient = useQueryClient();
  const showErrorToast = useRequestErrorToast();
  const {
    toast
  } = useToast();
  const router = useRouter();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = postOrgOnboardingConfigsByIdCopyMutation();
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== queryClient || $[3] !== router || $[4] !== t || $[5] !== toast) {
    t2 = async response => {
      toast({
        title: t(_temp),
        description: t(_temp2)
      });
      await queryClient.invalidateQueries();
      router.push({
        pathname: `/playbooks/${response.playbookId}`
      });
    };
    $[2] = queryClient;
    $[3] = router;
    $[4] = t;
    $[5] = toast;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== showErrorToast || $[8] !== t2) {
    t3 = {
      ...t1,
      onSuccess: t2,
      onError: showErrorToast
    };
    $[7] = showErrorToast;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return useMutation(t3);
};
export default useDuplicatePlaybook;
function _temp($) {
  return $.success.title;
}
function _temp2($_0) {
  return $_0.success.description;
}